export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10378.8f64f955.jpg";